import * as React from 'react'
import {Component, Fragment} from 'react'
import {findDOMNode} from 'react-dom'
import {each, map, findIndex} from 'lodash'

///////////////////////////////////////////////////////////////////////////////

export type RovingTabIndexWrapperProps = {
  children?: any
  currentIdx?: number
  onSelect?: (value: string) => void
}

///////////////////////////////////////////////////////////////////////////////

export class RovingTabIndexWrapper extends Component<
  RovingTabIndexWrapperProps,
  any
> {
  private wrapper: HTMLElement
  private list: HTMLElement[]
  private currentIdx: number

  public static defaultProps: Partial<RovingTabIndexWrapperProps> = {
    currentIdx: null,
  }

  constructor(props) {
    super(props)

    this.onFocus = this.onFocus.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  componentDidMount() {
    this.init()
    this.addListeners()
  }

  componentDidUpdate() {
    this.removeListeners()
    this.init()
    this.addListeners()
  }

  componentWillUnmount() {
    this.removeListeners()
  }

  init() {
    let {currentIdx} = this.props

    this.wrapper = findDOMNode(this) as HTMLElement
    this.list = map(
      this.wrapper.querySelectorAll('[data-selectable=true]'),
      (el) => el as HTMLElement,
    )
    this.currentIdx = currentIdx !== null ? currentIdx : 0

    this.setTabbable()
    this.setSelected()
  }

  setTabbable() {
    each(this.list, (el, k) => {
      let tabIndex = k === this.currentIdx ? '0' : '-1'

      el.setAttribute('tabIndex', tabIndex)
    })
  }

  setSelected() {
    each(this.list, (el, k) => {
      let selected = k === this.currentIdx

      el.setAttribute('aria-selected', '' + selected)
    })
  }

  onSelect() {
    if (this.props.onSelect) {
      let el = this.list[this.currentIdx]
      let value = null

      if (el) {
        value = el.getAttribute('data-value')
      }

      if (value) {
        this.props.onSelect(value)
      }
    }
  }

  addListeners() {
    each(this.list, (el) => {
      el.addEventListener('focus', this.onFocus)
    })

    this.wrapper.addEventListener('keydown', this.onKeydown)
  }

  removeListeners() {
    each(this.list, (el) => {
      el.removeEventListener('focus', this.onFocus)
    })

    this.wrapper.removeEventListener('keydown', this.onKeydown)
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>
  }

  onFocus(e) {
    this.currentIdx = findIndex(this.list, (el) => el === e.target)
  }

  onKeydown(e) {
    let keyCode = e.which || e.keyCode

    // ArrowLeft, ArrowUp
    if (keyCode === 37 || keyCode === 38) {
      e.preventDefault()
      e.stopPropagation()
      this.focusPrev()
    }

    // ArrowRight, ArrowDown
    if (keyCode === 39 || keyCode === 40) {
      e.preventDefault()
      e.stopPropagation()
      this.focusNext()
    }
  }

  focusNext() {
    let idx = this.currentIdx + 1
    let el = this.list[idx]

    if (el) {
      this.currentIdx = idx

      this.setTabbable()
      this.setSelected()
      this.onSelect()
      el.focus()
    }
  }

  focusPrev() {
    let idx = this.currentIdx - 1
    let el = this.list[idx]

    if (el) {
      this.currentIdx = idx

      this.setTabbable()
      this.setSelected()
      this.onSelect()
      el.focus()
    }
  }
}
